import BaseObject from '../../base/base_object';
import WebLoginComponent from './web_login_component';
import EventsObjectBuilder from './events_object_builder';
import InitObjectBuilder from './init_object_builder';
import LoginErrorHandler from './login_error_handler';



export default class WebLoginServiceDependenciesFactory extends BaseObject {
    static CLASS = 'WebLoginServiceDependenciesFactory';

    createWebLoginComponent(params) {
        return WebLoginComponent.create(params);
    }

    createEventsObjectBuilder(params) {
        return EventsObjectBuilder.create(params);
    }

    createInitObjectBuilder(params) {
        return InitObjectBuilder.create(params);
    }

    createLoginErrorHandler(params) {
        return LoginErrorHandler.create(params);
    }
}